/* eslint-disable */

import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';



export const SvgPeople = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 45 50">
        <G id="Bar-with-caption-box" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-48.000000, -73.000000)" strokeLinecap="round" strokeLinejoin="round">
            <G id="Group-2" transform="translate(50.000000, 75.000000)" stroke="#1A1A1A" strokeWidth="3">
                <Path d="M41,46 L41,41 C41,35.4771525 36.4109187,31 30.75,31 L10.25,31 C4.58908131,31 0,35.4771525 0,41 L0,46" id="Shape"></Path>
                <Circle id="Oval" cx="20" cy="10" r="10"></Circle>
            </G>
        </G>
    </Svg>)
}

